const env =
	typeof process !== "undefined"
		? process.env
		: ({} as Record<string, string | undefined>);

export const API_BASE = (env.BUN_PUBLIC_API_URL || "").replace(/\/$/, "");

export const API_V1 = `${API_BASE}/api/v1/blogs`;
